import { Injectable, NgZone } from '@angular/core';
import * as Rx from 'rxjs';
import { observeOn } from 'rxjs/operators';
import { enterZone, leaveZone } from './zone-utils';

@Injectable()
export class TimeUtils {
  constructor(private ngZone: NgZone) {}

  setTimeout(callback: (...args: any[]) => void, timeout: number): number {
    return this.ngZone.runOutsideAngular(() =>
      // tslint:disable-next-line:validate-timers
      window.setTimeout(() => this.ngZone.run(callback), timeout),
    );
  }

  rxTimer(
    delay: number,
    scheduler: Rx.Scheduler = Rx.asyncScheduler,
  ): Rx.Observable<number> {
    // tslint:disable-next-line:validate-timers
    return Rx.timer(delay, leaveZone(this.ngZone, scheduler)).pipe(
      observeOn(enterZone(this.ngZone, scheduler)),
    );
  }
}
